import React from 'react';

import { SxProps, Theme, Typography } from '@mui/material';

/** Small brand-colored label above an aside column. */
export const AsideLabel: React.FC<Readonly<{ children: string }>> = ({ children }) => (
  <Typography variant="text-sm-semibold" sx={labelSx}>
    {children}
  </Typography>
);

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-brand-primary'],
});
